<div class="c-subnav">
  <h4 class="c-subnav__title">
    <ls-sidebar-button></ls-sidebar-button>
    <ng-content select="[navigation]"></ng-content>
    <span id="{{ currentLocation }}">{{ currentLocation | lsTranslate }}</span>
    <ng-content select="[version]"></ng-content>
  </h4>
  <div class="c-subnav__actions">
    <ng-content select="[buttons]"></ng-content>
  </div>
</div>

<div ls-dynamic-translation id="Customers" i18n="Customers">Customers</div>

<div ls-dynamic-translation id="Invoices" i18n="Invoices">Invoices</div>

<div ls-dynamic-translation id="Printer Templates" i18n="Printer Templates">
  Printer Templates
</div>

<div ls-dynamic-translation id="Floorplan Builder" i18n="Floorplan Builder">
  Floorplan Builder
</div>

<div ls-dynamic-translation id="My Receipts" i18n="My Receipts">
  My Receipts
</div>

<div ls-dynamic-translation id="Account Information" i18n="Account Information">
  Account Information
</div>

<div ls-dynamic-translation id="Receipt Reports" i18n="Receipt Reports">
  Receipt Reports
</div>

<div ls-dynamic-translation id="Labour Reports" i18n="Labour Reports">
  Labour Reports
</div>

<div ls-dynamic-translation id="Day Reports" i18n="Day Reports">
  Day Reports
</div>

<div ls-dynamic-translation id="Week Reports" i18n="Week Reports">
  Week Reports
</div>

<div ls-dynamic-translation id="Month Reports" i18n="Month Reports">
  Month Reports
</div>

<div ls-dynamic-translation id="Shift Reports" i18n="Shift Reports">
  Shift Reports
</div>

<div ls-dynamic-translation id="IRS Reports" i18n="IRS Reports">
  IRS Reports
</div>

<div ls-dynamic-translation id="Hour Reports" i18n="Hour Reports">
  Hour Reports
</div>

<div ls-dynamic-translation id="User Reports" i18n="User Reports">
  User Reports
</div>

<div ls-dynamic-translation id="Revenue Reports" i18n="Revenue Reports">
  Revenue Reports
</div>

<div ls-dynamic-translation id="Advanced Reporting" i18n="Advanced Reporting">
  Advanced Reporting
</div>

<div ls-dynamic-translation id="Category Reports" i18n="Category Reports">
  Category Reports
</div>

<div ls-dynamic-translation id="Ingredient Reports" i18n="Ingredient Reports">
  Ingredient Reports
</div>

<div ls-dynamic-translation id="Support Dashboard" i18n="Support Dashboard">
  Support Dashboard
</div>

<div ls-dynamic-translation id="Device Logs" i18n="Device Logs">
  Device Logs
</div>

<div ls-dynamic-translation id="Product Reports" i18n="Product Reports">
  Product Reports
</div>

<div ls-dynamic-translation id="Payment Processors" i18n="Payment Processors">
  Payment Processors
</div>

<div ls-dynamic-translation id="Payment Processing" i18n="Payment Processing">
  Payment Processing
</div>

<div ls-dynamic-translation id="Payment Terminals" i18n="Payment Terminals">
  Payment Terminals
</div>

<div ls-dynamic-translation id="Payment Types" i18n="Payment Types">
  Payment Types
</div>

<div
  ls-dynamic-translation
  id="Combined Receipts Report"
  i18n="Combined Receipts Report"
>
  Combined Receipts Report
</div>

<div
  ls-dynamic-translation
  id="Combined Products Report"
  i18n="Combined Products Report"
>
  Combined Products Report
</div>

<div ls-dynamic-translation id="Printers" i18n="Printers">Printers</div>

<div ls-dynamic-translation id="Modifiers" i18n="Modifiers">Modifiers</div>

<div ls-dynamic-translation id="Categories" i18n="Categories">Categories</div>

<div ls-dynamic-translation id="Products" i18n="Products">Products</div>

<div ls-dynamic-translation id="Cashdrawers" i18n="Cashdrawers">
  Cashdrawers
</div>

<div
  ls-dynamic-translation
  id="Combined Revenue Report"
  i18n="Combined Revenue Report"
>
  Combined Revenue Report
</div>

<div
  ls-dynamic-translation
  id="Combined Waiter Report"
  i18n="Combined Waiter Report"
>
  Combined Waiter Report
</div>

<div ls-dynamic-translation id="User Groups" i18n="User Groups">
  User Groups
</div>

<div ls-dynamic-translation id="Ingredients" i18n="Ingredients">
  Ingredients
</div>

<div
  ls-dynamic-translation
  id="Notification Settings"
  i18n="Notification Settings"
>
  Notification Settings
</div>

<div ls-dynamic-translation id="Timed Events" i18n="Timed Events">
  Timed Events
</div>

<div
  ls-dynamic-translation
  id="Combined Days Report"
  i18n="Combined Days Report"
>
  Combined Days Report
</div>

<div ls-dynamic-translation id="Users" i18n="Users">Users</div>

<div
  ls-dynamic-translation
  id="Combined Week Report"
  i18n="Combined Week Report"
>
  Combined Week Report
</div>

<div
  ls-dynamic-translation
  id="Combined Categories Report"
  i18n="Combined Categories Report"
>
  Combined Categories Report
</div>

<div
  ls-dynamic-translation
  id="Combined Months Report"
  i18n="Combined Months Report"
>
  Combined Months Report
</div>

<div
  ls-dynamic-translation
  id="Closing Reports"
  i18n="Breadcrumb|Breadcrumb of closing reports page @@breadcrumbClosingReports"
>
  Closing Reports
</div>

<div
  ls-dynamic-translation
  id="Gift Cards"
  i18n="Breadcrumb|Breadcrumb of gift cards page @@breadcrumbGiftCards"
>
  Gift Cards
</div>

<div
  ls-dynamic-translation
  id="Gift Card Transactions"
  i18n="Breadcrumb|Breadcrumb of gift card transactions page @@breadcrumbGiftCardTransactions"
>
  Gift Card Transactions
</div>

<div
  ls-dynamic-translation
  id="CFD App Settings"
  i18n="CFD settings|Title for CFD settings page @@titleCfdAppSettings"
>
  CFD App Settings
</div>

<div
  ls-dynamic-translation
  id="Kitchen App Settings"
  i18n="Kitchen settings|Title for kitchen settings page @@titleKitchenAppSettings"
>
  Kitchen App Settings
</div>
